<script>
    export let data = null;
</script>

{#if data && data.length}
    <div class="row">
        <div class="col-md-6">
            <label>Ελληνικά</label>
        </div>
        <div class="col-md-6">
            <label>Αγγλικά</label>
        </div>
    </div>
    {#each data as item, index}
        <div class="row">
            <div class="col-md-6 left-input">
                <input type="text" class="form-control" bind:value={item.el}>
            </div>
            <div class="col-md-6 right-input">
                <input type="text" class="form-control" bind:value={item.en}>
            </div>
        </div>
    {/each}
{/if}

<style>
    .left-input {
        padding-right: 1px;
        margin-bottom: 2px;
    }

    .right-input {
        padding-left: 1px;
        margin-bottom: 2px;
    }
</style>